module.exports = __webpack_public_path__ + "img/eicon2.9f17df55.png";